import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import SelectSearch, { fuzzySearch } from "react-select-search";
import { AiOutlineUser } from "react-icons/ai";
import { useDispatch, useSelector } from "react-redux";
import { Formik, Form } from "formik";
import * as yup from "yup";
import { API_ERROR_500 } from "../../../../config";
import { setLoading, getStageScreen } from "../../../../redux";
import TNCModal from "../../components/TNC";
import TextInput from "../../components/TextInput";
import Title from "../../components/Title";
import Button from "../../components/Button";
import { validateOnNumber } from "../../../../utils";
import "./style.css";
import { Tooltip, OverlayTrigger, Modal } from "react-bootstrap";
import InputTitle from "designs/v1/components/InputTitle";

const LoginRegister = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isCloseKyc = sessionStorage.getItem("closeKYC");
  const isModifyKyc = sessionStorage.getItem("modifyKYC");
  let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
  API_URL_NEW = API_URL_NEW ? API_URL_NEW.substring(0, API_URL_NEW.length - 1) : "";
  const login = {
    emailOrPhone: "",
    otp: "",
  };
  const register = {
    emailPhone: "",
    tnc: false,
    mobileOtp: "",
    emailOtp: "",
  };
  const { loading } = useSelector((state) => state.common);
  const { inputLabelColor, inputIconColor } = useSelector((state) => state.theme);
  // login
  const [Lvalues, setLValues] = useState(login);
  const [Lerrors, setLErrors] = useState(login);
  const [LsendOtp, setLSendOtp] = useState(false);
  const [loginTimer, setLoginTimer] = useState({
    tried: 0,
    counter: 60,
  });
  const [isVerified, setIsVerified] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  //
  const [isPhone, setIsPhone] = useState(false);

  // register
  const [Rvalues, setRValues] = useState(register);
  const [Rerrors, setRErrors] = useState(register);
  const [RFields, setRFields] = useState(null);
  const [RmobileOtp, setRMobileOtp] = useState(false);
  const [REmailOtp, setREmailOtp] = useState(false);
  const [RMobileTimer, setRMobileTimer] = useState({
    tried: 0,
    counter: 60,
  });
  const [REmailTimer, setREmailTimer] = useState({
    tried: 0,
    counter: 60,
  });
  const [promoCode, setPromoCode] = useState([]);
  const [promoCodeInfo, setPromoCodeInfo] = useState(null);
  const [referralCode, setReferralCode] = useState(false);
  const [tokenVerify, setTokenVerify] = useState(null);
  const [isMobileVerified, setIsMobileVerified] = useState(false);
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [isMobileOtp, setIsMobileOtp] = useState(false);
  const [IsEmailOtp, setIsEmailOtp] = useState(false);

  // modal
  const [showModal, setShowModal] = useState(false);
  const [showPhoneOtpModal, setShowPhoneOtpModal] = useState(false);
  const [showEmailOtpModal, setShowEmailOtpModal] = useState(false);

  useEffect(() => {
    handleEmailorPhoneValidate(Lvalues);
  }, [Lvalues.emailOrPhone]);

  useEffect(() => {
    handleOtpValidate(Lvalues);
  }, [Lvalues.otp]);

  useEffect(() => {
    handleRegisterValidate(Rvalues);
  }, [Rvalues.emailPhone]);

  useEffect(() => {
    let intervalId;
    if (loginTimer.counter > 0 && LsendOtp) {
      intervalId = setInterval(() => {
        setLoginTimer((prev) => {
          return { ...prev, counter: prev.counter - 1 };
        });
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [loginTimer, LsendOtp]);

  useEffect(() => {
    let intervalId;
    if (RMobileTimer.counter > 0 && RmobileOtp) {
      intervalId = setInterval(() => {
        setRMobileTimer((prev) => {
          return { ...prev, counter: prev.counter - 1 };
        });
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [RMobileTimer, RmobileOtp]);

  useEffect(() => {
    let intervalId;
    if (REmailTimer.counter > 0 && REmailOtp) {
      intervalId = setInterval(() => {
        setREmailTimer((prev) => {
          return { ...prev, counter: prev.counter - 1 };
        });
      }, 1000);
    }
    return () => clearInterval(intervalId);
  }, [REmailTimer, REmailOtp]);

  useEffect(() => {
    isVerified && loadPromoCode();
  }, [isVerified]);

  useEffect(() => {
    if (RFields) {
      let _referalCode = window.sessionStorage.getItem("referal_code");
      let _promoCode = window.sessionStorage.getItem("promo_code");
      if (_referalCode) {
        let obj = {};
        for (let i in RFields.signup) {
          if (RFields.signup[i].fields_meta == "Referral Code") {
            obj[RFields.signup[i].field_name] = _referalCode;
          } else {
            obj[RFields.signup[i].field_name] = "";
          }
          setRValues({
            ...Rvalues,
            ...obj,
          });
        }
      }
      if (_promoCode) {
        let obj = {};
        for (let i in RFields.signup) {
          if (RFields.signup[i].fields_meta == "Promocode") {
            obj[RFields.signup[i].field_name] = _referalCode;
          } else {
            obj[RFields.signup[i].field_name] = "";
          }
          setRValues({
            ...Rvalues,
            ...obj,
          });
        }
      }
    }
  }, [RFields]);

  useEffect(() => {
    Rvalues.mobileOtp.length === 6 && verifySignupMobileOtp();
  }, [Rvalues.mobileOtp]);

  useEffect(() => {
    Rvalues.emailOtp.length === 6 && verifySignupEmailOtp();
  }, [Rvalues.emailOtp]);

  const resetTimer = () => {
    handleOtpRequest();
  };

  const resetMobileTimer = () => {
    handleSignupOtp("phone");
  };

  const resetEmailTimer = () => {
    handleSignupOtp("email");
  };

  const handleLoginChange = (event) => {
    const { name, value } = event.target;
    setLValues({
      ...Lvalues,
      [name]: value,
    });
  };

  const handleRegisterPhoneChange = (event) => {
    const { name, value } = event.target;
    setRValues({
      ...Rvalues,
      [name]: value,
    });
  };

  const handleRegisterEmailChange = (event) => {
    const { name, value } = event.target;
    setRValues({
      ...Rvalues,
      [name]: value,
    });
  };

  const handleRegisterChange = (event) => {
    const { name, value } = event.target;
    setRValues({
      ...Rvalues,
      [name]: value,
    });
  };

  const handleRegisterCheckBox = (e) => {
    const { name, checked } = e.target;
    setRValues({
      ...Rvalues,
      [name]: checked,
    });
  };

  const handlePromoCode = (value, name) => {
    getPromoCodeDetails(value);
    setRValues({
      ...Rvalues,
      [name]: value,
    });
  };

  const handleReferralCode = (event, name) => {
    const { value } = event.target;
    setRValues({
      ...Rvalues,
      [name]: value,
    });
  };

  // To handle navigation to next page
  useEffect(() => {
    if (isMobileVerified && isEmailVerified) {
      toast.success("Your registration is successful");
      dispatch(getStageScreen());
      // dispatch(updateScreenPage());
    }
  }, [isMobileVerified, isEmailVerified]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const loadPromoCode = async () => {
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    };
    try {
      const resp = await axios.get(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.promocode.api.get_promocode`,
        headers
      );
      let arr = [];
      resp.data?.data.forEach((element) => {
        return arr.push({
          name: element.name,
          value: element.name,
          short_description: element.short_description,
        });
      });
      setPromoCode(arr);
    } catch (err) {
      const { response } = err;
    }
  };

  const getPromoCodeDetails = (value) => {
    axios
      .post(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.promocode.api.get_promocode_details`,
        {
          promocode: value,
        }
      )
      .then((result) => {
        const { data } = result?.data;
        setPromoCodeInfo(data);
      })
      .catch((error) => { });
  };

  const checkReferalCode = async (label) => {
    if (!Rvalues[label]) {
      return setReferralCode(false);
    }
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    };
    axios
      .post(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.subbroker.api.check_referral_code`,
        { referral_code: Rvalues[label] },
        headers
      )
      .then((data) => {
        setReferralCode(false);
      })
      .catch((err) => {
        setReferralCode(true);
      });
  };

  const getSignupField = async () => {
    try {
      const resp = await axios.post(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_page.signup.api.get_signup_page_fields`,
        {}
      );
      let fieldArr = {};
      const fields = resp?.data?.data?.signup?.map((item) => {
        fieldArr[item.field_name] = "";
        return fieldArr;
      });
      setIsVerified(true);
      setRFields(resp?.data?.data);
      setRValues({
        ...Rvalues,
        ...fields[0],
      });
    } catch {
      setIsVerified(false);
    }
  };

  const handleOtpRequest = async () => {
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    };
    let payload = null;
    if (!Lvalues.emailOrPhone.includes("@")) {
      payload = {
        type: "phone",
        entity: `91${Lvalues.emailOrPhone}`,
        otp: Lvalues.otp,
      };
    } else {
      payload = {
        type: "email",
        entity: `${Lvalues.emailOrPhone}`,
        otp: Lvalues.otp,
      };
    }
    try {
      const url =
        isCloseKyc || isModifyKyc
          ? `${API_URL_NEW}/api/method/kyc_customizations.re_kyc.apis.authentication.api.request_login_otp`
          : `${API_URL_NEW}/api/method/kyc_customizations.apis.authentication.api.request_login_otp`;
      const resp = await axios.post(url, payload, headers);
      setLoginTimer((prev) => {
        return { ...prev, tried: prev.tried + 1, counter: resp?.data?.data?.resend_otp };
      });
    } catch (err) {
      const { response } = err;
      console.log("response", response);
    }
  };

  const verifySignupMobileOtp = async () => {
    setIsMobileOtp(true);
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    };
    const payload = {
      type: "phone",
      token: tokenVerify,
      otp: Rvalues.mobileOtp,
    };
    try {
      let resp = await axios.post(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.authentication.api.verify_signup_otp`,
        payload,
        headers
      );
      window.sessionStorage.setItem("token", resp?.data?.token);
      setIsMobileVerified(true);
      setIsMobileOtp(false);
    } catch (error) {
      const { response } = error;
      setIsMobileOtp(false);
      if (response?.data?.code === 401) {
        return toast.error(response?.data?.message);
      }
      toast.error("Please enter correct OTP");
    }
  };

  const handleSignupOtp = async (type) => {
    try {
      await axios.post(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.authentication.api.resend_singup_otp`,
        {
          token: tokenVerify,
          send_phone_otp: type === "phone",
          send_email_otp: type === "email",
        }
      );
      if (type === "email") {
        setREmailTimer((prev) => {
          return { ...prev, tried: prev.tried + 1, counter: 60 };
        });
      } else {
        setRMobileTimer((prev) => {
          return {
            ...prev,
            tried: prev.tried + 1,
            counter: 60,
          };
        });
      }
    } catch (error) {
      const { response } = error || {};
      toast.error(response?.data?.message || API_ERROR_500);
    }
  };

  const verifySignupEmailOtp = async () => {
    setIsEmailOtp(true);
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    };
    const payload = {
      type: "email",
      token: tokenVerify,
      otp: Rvalues.emailOtp,
    };
    try {
      let resp = await axios.post(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.authentication.api.verify_signup_otp`,
        payload,
        headers
      );
      window.sessionStorage.setItem("token", resp?.data?.token);
      setIsEmailVerified(true);
      setIsEmailOtp(false);
    } catch (error) {
      const { response } = error;
      setIsEmailOtp(false);
      if (response?.data?.code === 401) {
        return toast.error(response?.data?.message);
      }
      toast.error("Please enter correct OTP");
    }
  };

  const handleSignIn = async (event) => {
    event.preventDefault();
    setSubmitted(true);
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
    if (!isVerified) {
      if (!LsendOtp) {
        if (handleEmailorPhoneValidate(Lvalues)) {
          if (!Lvalues.emailOrPhone.includes("@")) {
            dispatch(setLoading(true));
            try {
              const url =
                isCloseKyc || isModifyKyc
                  ? `${API_URL_NEW}/api/method/kyc_customizations.re_kyc.apis.authentication.api.check_mobile_register`
                  : `${API_URL_NEW}/api/method/kyc_customizations.apis.authentication.api.check_mobile_register`;
              await axios.post(url, { mobile: `91${Lvalues.emailOrPhone}` });
              handleOtpRequest();
              setLSendOtp(true);
              setIsVerified(false);
              dispatch(setLoading(false));
            } catch (error) {
              const { response } = error || {};
              dispatch(setLoading(false));
              if (isCloseKyc || isModifyKyc) {
                return toast.error(`${response.data?.message}.`);
              }
              if ([404].includes(response.status)) {
                setSubmitted(false);
                setIsVerified(true);
                setIsPhone(true);
                getSignupField();
                return;
              }
              toast.error(response?.data?.message || "Something went wrong");
            }
          } else {
            dispatch(setLoading(true));
            try {
              const url =
                isCloseKyc || isModifyKyc
                  ? `${API_URL_NEW}/api/method/kyc_customizations.re_kyc.apis.authentication.api.check_email_register`
                  : `${API_URL_NEW}/api/method/kyc_customizations.apis.authentication.api.check_email_register`;
              await axios.post(url, { email: Lvalues.emailOrPhone });
              handleOtpRequest();
              setLSendOtp(true);
              setIsVerified(false);
              dispatch(setLoading(false));
            } catch (error) {
              const { response } = error || {};
              dispatch(setLoading(false));
              if (isCloseKyc || isModifyKyc) {
                return toast.error(response.data?.message);
              }
              if ([404].includes(response.status)) {
                setSubmitted(false);
                setIsVerified(true);
                setIsPhone(false);
                getSignupField();
                return;
              }
              toast.error(response?.data?.message || "Something went wrong");
            }
          }
        }
      } else {
        if (handleOtpValidate(Lvalues)) {
          dispatch(setLoading(true));
          let payload = null;
          if (!Lvalues.emailOrPhone.includes("@")) {
            payload = {
              type: "phone",
              entity: `91${Lvalues.emailOrPhone}`,
              otp: Lvalues.otp,
            };
          } else {
            payload = {
              type: "email",
              entity: `${Lvalues.emailOrPhone}`,
              otp: Lvalues.otp,
            };
          }
          try {
            const url =
              isCloseKyc || isModifyKyc
                ? `${API_URL_NEW}/api/method/kyc_customizations.re_kyc.apis.authentication.api.verify_login_otp`
                : `${API_URL_NEW}/api/method/kyc_customizations.apis.authentication.api.verify_login_otp`;
            let resp = await axios.post(url, payload);
            window.sessionStorage.setItem("token", resp?.data?.token);
            const brokerId = window.sessionStorage.getItem("broker_id");
            if (isCloseKyc) {
              delete payload.otp;
              sessionStorage.setItem("user", JSON.stringify(payload));
              history.push(`/close-kyc/${brokerId}`);
            } else if (isModifyKyc) {
              delete payload.otp;
              sessionStorage.setItem("user", JSON.stringify(payload));
              history.push(`/modify-kyc/${brokerId}`);
            } else {
              dispatch(getStageScreen());
            }
            // dispatch(updateScreenPage());
            dispatch(setLoading(false));
            toast.success("Login Successful");
          } catch (error) {
            const { response } = error;
            dispatch(setLoading(false));
            if (response?.data?.code === 401) {
              return toast.error(response?.data?.message);
            }
            toast.error("Please Enter Correct OTP");
          }
        }
      }
    } else {
      if (handleRegisterValidate(Rvalues) && !referralCode) {
        dispatch(setLoading(true));
        const headers = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          },
        };
        let payload = null;
        if (!Lvalues.emailOrPhone.includes("@")) {
          payload = {
            phone: `91${Lvalues.emailOrPhone}`,
            email: Rvalues.emailPhone,
            phone_belong: belong1,
            email_belong: belong2,
            ...Rvalues,
          };
        } else {
          payload = {
            email: `${Lvalues.emailOrPhone}`,
            phone: `91${Rvalues.emailPhone}`,
            phone_belong: belong2,
            email_belong: belong1,
            ...Rvalues,
          };
        }
        console.log("payload----", payload);
        try {
          let resp = await axios.post(
            `${API_URL_NEW}/api/method/kyc_customizations.apis.authentication.api.request_signup_otp`,
            payload,
            headers
          );
          setTokenVerify(resp.data?.data?.token);
          setRMobileOtp(true);
          setREmailOtp(true);
          dispatch(setLoading(false));
        } catch (error) {
          dispatch(setLoading(false));
          const { response } = error;
          if (response?.data?.code === 400 || response?.data?.code === 403) {
            return toast.error(response?.data?.message);
          }
          // toast.error("Please Enter Correct OTP");
        }
      }
    }
  };

  const handleEmailorPhoneValidate = (values) => {
    let regex = new RegExp(
      "^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+.)+([a-zA-Z0-9]{2,4})|(^[0-9]{10})+$"
    );
    let errors = {};
    let isValid = true;
    if (!regex.test(values["emailOrPhone"])) {
      isValid = false;
      errors["emailOrPhone"] = "Please enter valid phone number or email";
    }
    if (!values["emailOrPhone"]) {
      isValid = false;
      errors["emailOrPhone"] = "Please enter valid phone number or email";
    }
    setLErrors(errors);
    return isValid;
  };

  const handleOtpValidate = (values) => {
    let errors = {};
    let isValid = true;
    if (!values["otp"]) {
      isValid = false;
      errors["otp"] = "Please enter otp code.";
    }
    setLErrors(errors);
    return isValid;
  };

  const handleRegisterValidate = (values) => {
    let errors = {};
    let isValid = true;
    if (isPhone) {
      if (typeof values["emailPhone"] !== "undefined") {
        let pattern = new RegExp(
          /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
        );
        if (!pattern.test(values["emailPhone"])) {
          isValid = false;
          errors["emailPhone"] = "Please enter valid email address.";
        }
      }
      if (!values["emailPhone"]) {
        isValid = false;
        errors["emailPhone"] = "Please enter email address.";
      }
    } else {
      if (typeof values["emailPhone"] !== "undefined") {
        var pattern = new RegExp(/^[0-9\b]+$/);
        if (!pattern.test(values["emailPhone"])) {
          isValid = false;
          errors["emailPhone"] = "Please enter valid phone number.";
        } else if (values["emailPhone"].length != 10) {
          isValid = false;
          errors["emailPhone"] = "Please enter valid phone number.";
        }
      }
      if (!values["emailPhone"]) {
        isValid = false;
        errors["emailPhone"] = "Please enter phone number.";
      }
    }
    setRErrors(errors);
    return isValid;
  };

  let LogoImage = window.sessionStorage.getItem("logo");

  const changeFieldArr = (arr) => {
    let res = [];
    if (arr?.length > 0) {
      let textInput = arr?.filter((y) => y.field_type === "Data");
      let checkInput = arr?.filter((y) => y.field_type === "Check");
      res = [...textInput, ...checkInput];
    }
    return res;
  };

  const changePhoneApi = async (value, { setSubmitting, resetForm }) => {
    dispatch(setLoading(true));
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    };
    let payload = null;
    if (Lvalues.emailOrPhone.includes("@")) {
      payload = {
        ...Rvalues,
        phone: `91${value.newPhone}`,
        email: Lvalues.emailOrPhone,
        emailPhone: `91${value.newPhone}`,
      };
    } else {
      payload = {
        ...Rvalues,
        phone: `91${value.newPhone}`,
        email: Rvalues.emailPhone,
      };
    }
    console.log("payload", payload);
    try {
      let resp = await axios.post(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.authentication.api.request_signup_otp`,
        payload,
        headers
      );
      console.log(resp.data);
      setSubmitting(false);
      resetForm();
      setTokenVerify(resp.data?.data?.token);
      setShowPhoneOtpModal(false);
      if (Lvalues.emailOrPhone.includes("@")) {
        setRValues({ ...Rvalues, emailPhone: value.newPhone });
      } else {
        setLValues({ ...Lvalues, emailOrPhone: value.newPhone });
      }
      setRMobileTimer({ tried: 0, counter: 60 });
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      const { response } = error;
      if (response?.data?.code === 400 || response?.data?.code === 403) {
        return toast.error(response?.data?.message);
      }
      toast.error("Please Enter Correct OTP");
    }
  };

  const changeEmailApi = async (value, { setSubmitting, resetForm }) => {
    dispatch(setLoading(true));
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    };
    let payload = null;
    if (Lvalues.emailOrPhone.includes("@")) {
      payload = {
        ...Rvalues,
        phone: `91${Rvalues.emailPhone}`,
        email: value.newEmail,
        emailOrPhone: value.newEmail,

      };
    } else {
      payload = {
        ...Rvalues,
        phone: `91${Lvalues.emailOrPhone}`,
        email: value.newEmail,
        emailPhone: value.newEmail,
      };
    }
    console.log("payload", payload);
    try {
      let resp = await axios.post(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.authentication.api.request_signup_otp`,
        payload,
        headers
      );
      console.log(resp.data);
      setSubmitting(false);
      resetForm();
      setTokenVerify(resp.data?.data?.token);
      setShowEmailOtpModal(false);
      if (Lvalues.emailOrPhone.includes("@")) {
        setLValues({ ...Lvalues, emailOrPhone: value.newEmail });
      } else {
        setRValues({ ...Rvalues, emailPhone: value.newEmail });
      }
      setREmailTimer({ tried: 0, counter: 60 });
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
      const { response } = error;
      if (response?.data?.code === 400 || response?.data?.code === 403) {
        return toast.error(response?.data?.message);
      }
      toast.error("Please Enter Correct OTP");
    }
  };

  const otpPhoneNumber = () => {
    let res = "";
    if (!Lvalues.emailOrPhone.includes("@")) {
      res = Lvalues.emailOrPhone;
    } else {
      res = Rvalues.emailPhone;
    }
    return res;
  };

  const otpEmailAddress = () => {
    let res = "";
    if (Lvalues.emailOrPhone.includes("@")) {
      res = Lvalues.emailOrPhone;
    } else {
      res = Rvalues.emailPhone;
    }
    return res;
  };

  const getPageTitle = (isSignin) => {
    if (isCloseKyc) {
      return "Close Kyc";
    }
    if (isModifyKyc) {
      return "Re-Kyc";
    }
    return isSignin ? "Sign in" : "Get Started";
  };

  const optionsBelong = ['Self', 'Spouse', 'Dependent Parent', 'Dependent Children'];
  const [belong1, setBelong1] = useState('Self')
  const [belong2, setBelong2] = useState('Self')

  const [showBelongsFields, setShowBelongsFields] = useState(false);

  useEffect(() => {
    if (API_URL_NEW == 'https://scmcbrkg.in' || API_URL_NEW == 'https://consortium.brkscmcj.in') {
      setShowBelongsFields(true)
    }
  }, [])


  return (
    <div className="row">
      <div className="col-md-12 p-0">
        {/* Logo */}
        <div className="text-center mb-4 mt-4">
          <img src={LogoImage} className="w-25" alt="logo" />
        </div>
        {isVerified ? (
          <>
            <Title title="Sign up" />
          </>
        ) : (
          <Title title={getPageTitle(LsendOtp)} />
        )}
        <form name="form" className="form" onSubmit={handleSignIn}>
          <div className="form-group">
            {!RmobileOtp && (
              <div className="row">
                <div className={`col-md-${showBelongsFields && isVerified ? '8' : '12'} col-12`}>
                  <TextInput
                    label="Enter Phone Number or Email*"
                    name="emailOrPhone"
                    icon={<AiOutlineUser color={inputIconColor} />}
                    placeholder="Email or Phone number"
                    value={Lvalues.emailOrPhone}
                    onChange={handleLoginChange}
                    disabled={LsendOtp || isVerified}
                    error={submitted && !!Lerrors.emailOrPhone && Lerrors.emailOrPhone}
                  />
                </div>
                {isVerified && showBelongsFields &&
                  <div className="col-md-4 mt-4 d-flex flex-column justify-content-end">
                    <div>
                      <InputTitle
                        title={isVerified ? isPhone ? "Phone Belongs To" : "Email Belongs To" : "Belongs To"}
                      />
                      <select
                        style={{ width: '100%', border: 0, borderBottomWidth: 1, borderBottomColor: "black", borderBottomStyle: "solid", outline: 0 }}
                        onChange={(e) => setBelong1(e.target.value)}
                        value={belong1}
                      >
                        {optionsBelong.map((data, key) => (
                          <option key={'belong1' + key}>{data}</option>
                        ))}
                      </select>
                    </div>
                  </div>
                }
              </div>
            )}
          </div>
          {LsendOtp && (
            <>
              <div className="form-group">
                <TextInput
                  label="Enter Otp*"
                  name="otp"
                  placeholder="Enter Otp"
                  value={Lvalues.otp}
                  onChange={handleLoginChange}
                  maxLength="6"
                  error={submitted && !!Lerrors.otp && Lerrors.otp}
                />
              </div>
              <button
                type="button"
                className="btn btn-sm mt-2"
                disabled={loginTimer.counter > 0}
                onClick={() => resetTimer()}
                style={{ color: inputLabelColor }}
              >
                Resend OTP
                {loginTimer.counter > 0 &&
                  loginTimer.tried > 1 &&
                  ` (${loginTimer.tried - 1} Tries)`}
              </button>
              <br />
              {loginTimer.counter > 0 && (
                <span className="btn-sm">{`You can resend OTP in ${loginTimer.counter} second`}</span>
              )}
            </>
          )}
          {isVerified && (
            <>
              <div className="form-group">
                <div className="row">
                  <div className={`col-md-${showBelongsFields ? '8' : '12'}`}>
                    {isPhone
                      ? !RmobileOtp && (
                        <TextInput
                          label="Email Address*"
                          name="emailPhone"
                          placeholder="Enter Email Address"
                          value={Rvalues.emailPhone}
                          onChange={handleRegisterEmailChange}
                          disabled={RmobileOtp}
                          error={submitted && !!Rerrors.emailPhone && Rerrors.emailPhone}
                        />
                      )
                      : !RmobileOtp && (
                        <TextInput
                          label="Phone Number*"
                          name="emailPhone"
                          placeholder="Enter Phone Number"
                          value={Rvalues.emailPhone}
                          onChange={handleRegisterPhoneChange}
                          disabled={RmobileOtp}
                          error={submitted && !!Rerrors.emailPhone && Rerrors.emailPhone}
                          maxLength="10"
                        />
                      )}
                  </div>
                  {!RmobileOtp && showBelongsFields &&
                    <div className="col-md-4 mt-4 d-flex flex-column justify-content-end">
                      <div>
                        <InputTitle
                          title={isVerified ? !isPhone ? "Phone Belongs To" : "Email Belongs To" : "Belongs To"}
                        />
                        <select
                          style={{ width: '100%', border: 0, borderBottomWidth: 1, borderBottomColor: "black", borderBottomStyle: "solid", outline: 0 }}
                          onChange={(e) => setBelong2(e.target.value)}
                          value={belong2}
                        >
                          {optionsBelong.map((data, key) => (
                            <option key={'belong2' + key}>{data}</option>
                          ))}

                        </select>
                      </div>
                    </div>
                  }
                </div>
              </div>
              <div>
                {!RmobileOtp &&
                  changeFieldArr(RFields?.signup).map((inputFields, index) => {
                    return (
                      <div key={index}>
                        {inputFields.fields_meta === "Promocode" && (
                          <div className="mb-4">
                            <label
                              className="custom-input-title mt-2"
                              style={{ color: inputLabelColor }}
                            >
                              {inputFields.field_label}
                            </label>
                            <SelectSearch
                              options={promoCode}
                              name={inputFields.field_name}
                              value={Rvalues[inputFields.field_name]}
                              placeholder={`Choose your ${inputFields.field_label}`}
                              search
                              filterOptions={fuzzySearch}
                              onChange={(e) => handlePromoCode(e, inputFields.field_name)}
                              className="selectoption"
                              required={inputFields.required}
                              disabled={RmobileOtp}
                              renderOption={(option) => {
                                let shortDescription = "";
                                for (let i in promoCode) {
                                  if (option.value == promoCode[i].name) {
                                    shortDescription = promoCode[i].short_description;
                                  }
                                }
                                return (
                                  <li title={shortDescription}>
                                    <OverlayTrigger
                                      placement="left"
                                      delay={{ show: 250, hide: 400 }}
                                      overlay={<Tooltip>{shortDescription}</Tooltip>}
                                    >
                                      <button type="button" {...option}>
                                        {option.value}
                                      </button>
                                    </OverlayTrigger>
                                  </li>
                                );
                              }}
                            />
                            <span style={{ color: inputLabelColor }}>
                              <small>{promoCodeInfo?.description}</small>
                            </span>
                          </div>
                        )}
                        {inputFields.fields_meta === "Referral Code" && (
                          <div className="form-group mb-4">
                            <TextInput
                              label={inputFields.field_label}
                              name={inputFields.field_name}
                              placeholder={`Enter ${inputFields.field_label}`}
                              value={Rvalues[inputFields.field_name] || ""}
                              onChange={(e) => {
                                handleReferralCode(e, inputFields.field_name);
                                if (!e.target.value) {
                                  setReferralCode(false);
                                }
                              }}
                              onBlur={() => checkReferalCode(inputFields.field_name)}
                              required={inputFields.required}
                              disabled={RmobileOtp}
                              error={
                                Rvalues[inputFields.field_name] &&
                                referralCode &&
                                "Invalid Referral Code"
                              }
                            />
                          </div>
                        )}
                        {(!inputFields.fields_meta ||
                          inputFields.fields_meta == "NA") && (
                            <>
                              {inputFields.field_type === "Check" ? (
                                <div className="mt-2 mb-2">
                                  <input
                                    name={inputFields.field_name}
                                    type="checkbox"
                                    // className="form-check-input"
                                    value={Rvalues[inputFields.field_name] || ""}
                                    onChange={handleRegisterCheckBox}
                                    required={inputFields.required}
                                    disabled={RmobileOtp}
                                  />
                                  &nbsp;&nbsp;
                                  <span
                                    className="form-check-label"
                                    style={{ color: inputLabelColor }}
                                  >
                                    {inputFields.field_label}
                                  </span>
                                </div>
                              ) : (
                                <div className="form-group mt-2">
                                  <TextInput
                                    label={inputFields.field_label}
                                    name={inputFields.field_name}
                                    placeholder={`Enter ${inputFields.field_name}`}
                                    value={Rvalues[inputFields.field_name]}
                                    onChange={handleRegisterChange}
                                    required={inputFields.required}
                                    disabled={RmobileOtp}
                                  />
                                </div>
                              )}
                            </>
                          )}
                      </div>
                    );
                  })}
                {!RmobileOtp && (
                  <div className=" mt-2">
                    <input
                      // className="form-check-input"
                      type="checkbox"
                      name="tnc"
                      // defaultChecked={true}
                      defaultChecked={Rvalues.tnc}
                      onChange={handleRegisterCheckBox}
                      disabled={RmobileOtp}
                    // disabled={true}
                    />
                    &nbsp;&nbsp;
                    <span className="form-check-label" style={{ color: inputLabelColor }}>
                      I accept all the{" "}
                      {RFields?.tnc?.tnc === "Text" ? (
                        <span
                          onClick={(e) => {
                            e.preventDefault();
                            setShowModal(true);
                          }}
                          className="span-link"
                        >
                          Terms and Conditions. *
                        </span>
                      ) : (
                        <a
                          href={RFields?.tnc?.tnc_file}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Terms and Conditions. *
                        </a>
                      )}
                    </span>
                  </div>
                )}
                {RmobileOtp && (
                  <>
                    <div className="form-group">
                      {!(isMobileVerified || isEmailVerified) && (
                        <div className="d-flex align-items-center my-2">
                          <span className="font-weight-bold">+91{otpPhoneNumber()}</span>
                          <button
                            type="button"
                            className="btn btn-sm mx-2 not-my-num-btn"
                            style={{ color: inputLabelColor }}
                            onClick={() => setShowPhoneOtpModal(true)}
                          >
                            Not my phone number
                          </button>
                        </div>
                      )}
                      <TextInput
                        marginTop={"mt-2"}
                        label="Enter Mobile Otp *"
                        name="mobileOtp"
                        placeholder="Enter Otp"
                        value={Rvalues.mobileOtp}
                        onChange={handleRegisterChange}
                        disabled={isMobileVerified}
                        maxLength="6"
                        error={submitted && !!Rerrors.mobileOtp && Rerrors.mobileOtp}
                        loading={isMobileOtp}
                      />
                    </div>
                    {!isMobileVerified && (
                      <>
                        <button
                          type="button"
                          className="btn btn-sm mt-2"
                          disabled={RMobileTimer.counter > 0}
                          onClick={() => resetMobileTimer()}
                          style={{ color: inputLabelColor }}
                        >
                          Resend OTP
                          {RMobileTimer.counter > 0 &&
                            RMobileTimer.tried > 0 &&
                            ` (${RMobileTimer.tried} Tries)`}
                        </button>
                        <br />
                        {RMobileTimer.counter > 0 && (
                          <span className="btn-sm">{`You can resend OTP in ${RMobileTimer.counter} second`}</span>
                        )}
                      </>
                    )}
                  </>
                )}

                {REmailOtp && (
                  <>
                    <div className="form-group">
                      {!(isMobileVerified || isEmailVerified) && (
                        <div className="d-flex align-items-center my-2">
                          <span className="font-weight-bold">{otpEmailAddress()}</span>
                          <button
                            type="button"
                            className="btn btn-sm mx-2 not-my-num-btn"
                            style={{ color: inputLabelColor }}
                            onClick={() => setShowEmailOtpModal(true)}
                          >
                            Not my email address
                          </button>
                        </div>
                      )}
                      <TextInput
                        marginTop={"mt-2"}
                        label="Enter Email Otp *"
                        name="emailOtp"
                        placeholder="Enter Otp"
                        value={Rvalues.emailOtp}
                        onChange={handleRegisterChange}
                        disabled={isEmailVerified}
                        maxLength="6"
                        error={submitted && !!Rerrors.emailOtp && Rerrors.emailOtp}
                        loading={IsEmailOtp}
                      />
                    </div>
                    {!isEmailVerified && (
                      <>
                        <button
                          type="button"
                          className="btn btn-sm mt-2"
                          disabled={REmailTimer.counter > 0}
                          onClick={() => resetEmailTimer()}
                          style={{ color: inputLabelColor }}
                        >
                          Resend OTP
                          {REmailTimer.counter > 0 &&
                            REmailTimer.tried > 0 &&
                            ` (${REmailTimer.tried} Tries)`}
                        </button>
                        <br />
                        {REmailTimer.counter > 0 && (
                          <span className="btn-sm">{`You can resend OTP in ${REmailTimer.counter} second`}</span>
                        )}
                      </>
                    )}
                  </>
                )}
                {RmobileOtp && (
                  <div className="mt-3">
                    <h5>
                      Please keep scanned copy of below mentioned documents handy so you
                      can upload them in no time.
                    </h5>
                    <ul>
                      <li>
                        PAN card ( If not retrievable from DigiLocker) [jpg, png, pdf]
                      </li>
                      <li>Aadhar card ( If DigiLocker not available) [jpg, png, pdf]</li>
                      <li>Specimen signature on blank white paper [jpg, png, pdf]</li>
                      <li>Bank account details & Cancel Cheque</li>
                      <li>
                        Income Proof (Bank Statement / ITR{" "}
                        {API_URL_NEW != "https://scmcbrke.in" && "/ PaySlip"} ) [pdf]
                      </li>
                      <li>Device with camera capabilities</li>
                    </ul>
                  </div>
                )}
              </div>

            </>
          )}
          <TNCModal
            show={showModal}
            text={RFields?.tnc?.tnc_text}
            onClose={handleCloseModal}
          />
          <div className="form-group my-4">
            {isVerified ? (
              <>
                {!RmobileOtp && (
                  <Button
                    title="Sign up"
                    disabled={(Rvalues.tnc ? false : true) || loading}
                  />
                )}
              </>
            ) : (
              <Button title={LsendOtp ? "Sign in" : "Submit"} disabled={loading} />
            )}
          </div>
        </form>
        <div className="mt-4">
          {API_URL_NEW == "https://scmcbrkf.in"
            &&
            <div className="text-center">
              Kindly Contact for Account Opening Support <br />
              Phone: <a href="tel:02261595164">022 6159 5164</a> / <a href="tel:02261595173">022 6159 5173</a> / <a href="tel:02261595100">022 6159 5100</a> <br />
              Email: <a target="_blank" href="mailto:kyc@acchoksi.com">kyc@acchoksi.com</a>
            </div>
          }
        </div>
      </div>
      <Modal show={showPhoneOtpModal}>
        <Modal.Header>
          <Modal.Title>Phone Number</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize={true}
            initialValues={{ newPhone: "" }}
            validationSchema={yup.object().shape({
              newPhone: yup
                .string()
                .min(10, "too short")
                .required("Phone number is required"),
            })}
            onSubmit={changePhoneApi}
          >
            {({ values, isValid, dirty, isSubmitting, setFieldValue }) => (
              <Form>
                <div className="form-group">
                  <TextInput
                    marginTop={"mt-2"}
                    label="Phone Number*"
                    name="newPhone"
                    placeholder="Enter Phone Number"
                    value={values.newPhone}
                    onChange={({ target }) => setFieldValue("newPhone", target.value)}
                    onKeyPress={validateOnNumber}
                    maxLength="10"
                  />
                </div>
                <div className="d-flex align-items-center justify-content-end my-4">
                  <div className="mx-1">
                    <Button
                      type="button"
                      title="Cancel"
                      handleClick={() => setShowPhoneOtpModal(false)}
                    />
                  </div>
                  <div className="mx-1">
                    <Button
                      title="Submit"
                      disabled={!isValid || !dirty || isSubmitting}
                    />
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
      <Modal show={showEmailOtpModal}>
        <Modal.Header>
          <Modal.Title>Email Address</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize={true}
            initialValues={{ newEmail: "" }}
            validationSchema={yup.object().shape({
              newEmail: yup
                .string()
                .email("Invalid email address")
                .required("Email address is required"),
            })}
            onSubmit={changeEmailApi}
          >
            {({ values, isValid, dirty, isSubmitting, setFieldValue }) => (
              <Form>
                <div className="form-group">
                  <TextInput
                    marginTop={"mt-2"}
                    label="Email Address*"
                    name="newEmail"
                    placeholder="Enter Email Address"
                    value={values.newEmail}
                    onChange={({ target }) => setFieldValue("newEmail", target.value)}
                  />
                </div>
                <div className="d-flex align-items-center justify-content-end my-4">
                  <div className="mx-1">
                    <Button
                      type="button"
                      title="Cancel"
                      handleClick={() => setShowEmailOtpModal(false)}
                    />
                  </div>
                  <div className="mx-1">
                    <Button
                      title="Submit"
                      disabled={!isValid || !dirty || isSubmitting}
                    />
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default LoginRegister;
